import SetupRouter from '../SetupRouter'
import SpaceCheckpoint from '../SpaceCheckpoint/SpaceCheckpoint'
import { DataCollectionConsumer } from '@eggplant/context'

const renderRouter = (isUsageReportingOn: boolean|undefined, isDataCollectionAllowed: boolean|undefined) => {
  if (!isUsageReportingOn) return <SpaceCheckpoint />

  if (isDataCollectionAllowed === undefined) return <SetupRouter />

  return <SpaceCheckpoint />
}

const DataCollectionCheckpoint = () =>
  <DataCollectionConsumer>
    {
      ({
        isUserReportingEnabled,
        isDataCollectionAllowed
      }) =>
        renderRouter(isUserReportingEnabled, isDataCollectionAllowed)
    }
  </DataCollectionConsumer>

export default DataCollectionCheckpoint
